document.addEventListener('DOMContentLoaded', function () {
  // AOS
  const isMobile = window.innerWidth <= 768;
  if (window.AOS) {
    AOS.init({
      offset: isMobile ? 50 : 120,
      duration: 700,
      easing: 'ease-in-out-quart',
    });
  }

  // Swiper
  if (window.Swiper) {
    document.querySelectorAll('.swiper').forEach((el) => {
      new Swiper(el, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
      });
    });
  }

});

document.addEventListener('alpine:init', () => {
  Alpine.data('popup', popup);
});

function popup() {

    return {
        isOpen: false,
        init() {
            const lastShown = localStorage.getItem('popupLastShown');
            const today = new Date().toDateString();

            // Only show if not shown today
            if (lastShown !== today) {
                setTimeout(() => {
                    this.isOpen = true;
                    localStorage.setItem('popupLastShown', today);
                }, 5000); // 5 seconds delay
            }
        },
        close() {
            this.isOpen = false;
        }
    }
}